module.exports = __webpack_public_path__ + "img/DE01808.da0a19b8.png";